import React, {useMemo} from 'react';
import ArrModal from '../../../common/arr-modal/ArrModal';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

interface SummaryDeleteModalProps {
  open: boolean;
  handleYesPress: () => void;
  handleGoBack: () => void;
  isCancel?: boolean;
  jobId?: number;
}

const SummaryDeleteModal = ({
  open,
  handleYesPress,
  handleGoBack,
  jobId,
  isCancel = false,
}: SummaryDeleteModalProps) => {
  const ModalData = useMemo(() => {
    const modalText = {
      isDelete: {
        title: t('ai.summarize.deleteModal.deleteTitle', {JobID: jobId ?? ''}),
        description: t('ai.summarize.deleteModal.deleteDescription'),
        note: t('ai.summarize.deleteModal.deleteNote'),
        button: t('ai.summarize.deleteModal.deleteButton'),
      },
      isCancel: {
        title: t('ai.summarize.deleteModal.cancelTitle', {JobID: jobId ?? ''}),
        description: t('ai.summarize.deleteModal.cancelDescription'),
        button: t('ai.summarize.deleteModal.cancelButton'),
        note: '',
      },
    };
    return isCancel ? modalText.isCancel : modalText.isDelete;
  }, [jobId, isCancel]);

  return (
    <ArrModal
      showModal={open}
      onClose={handleGoBack}
      title={ModalData.title}
      description={ModalData.description}
      showClose={false}
      dataTestId="summary-delete-modal"
      buttons={[
        {
          id: '1',
          label: t('ai.summarize.deleteModal.goBack'),
          onClick: handleGoBack,
          variant: 'secondary',
          dataTestId: 'sdm-goback-btn',
        },
        {
          id: '2',
          label: ModalData.button,
          onClick: handleYesPress,
          variant: 'primary',
          loading: false,
          dataTestId: 'sdm-yes-btn',
        },
      ]}
    >
      {ModalData?.note && (
        <Box mt={2}>
          <Typography
            className="typo-text.body2_size  desc-text-color"
            data-testid={`summary-delete-modal-note`}
          >
            {ModalData?.note}
          </Typography>
        </Box>
      )}
    </ArrModal>
  );
};

export default SummaryDeleteModal;
